import React from 'react';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import { Faq } from '@qover/organisms';
import { useFieldValue } from '@qover/hooks';
import { messages } from './trFaq.messages';

const ipidSingle = {
  'data-test': 'faq.IPIDSingleTrip',
  analyticsLabel: 'IPID Single trip',
  label: messages.ipidSingle,
  type: 'IPIDSingleTrip',
};

const ipidMulti = {
  'data-test': 'faq.IPIDMultiTrip',
  analyticsLabel: 'IPID Multi trip',
  label: messages.ipidMulti,
  type: 'IPIDMultiTrip',
};

const ipidYear = {
  'data-test': 'faq.IPIDYearTrip',
  analyticsLabel: 'IPID Year trip',
  label: messages.ipidYear,
  type: 'IPIDYearTrip',
};

const gcSingleMulti = {
  'data-test': 'faq.GCSingleMultiTrip',
  analyticsLabel: 'General Policy Conditions Single Multi trip',
  label: messages.gcSingleMulti,
  type: 'generalConditionsSingleMultiTrip',
};

const gcYear = {
  'data-test': 'faq.GCYearTrip',
  analyticsLabel: 'General Policy Conditions Year trip',
  label: messages.gcYear,
  type: 'generalConditionsYearTrip',
};

const documents = {
  [TripType.TRIP_TYPE_SINGLE_TRIP]: [ipidSingle, gcSingleMulti],
  [TripType.TRIP_TYPE_MULTI_TRIP]: [ipidMulti, gcSingleMulti],
  [TripType.TRIP_TYPE_YEAR_TRIP]: [ipidYear, gcYear],
  [TripType.TRIP_TYPE_UNSPECIFIED]: [
    ipidSingle,
    ipidMulti,
    ipidYear,
    gcSingleMulti,
    gcYear,
  ],
};

type TrFaq = {
  filterFaq?: boolean;
};

export const TrFaq: React.FC<TrFaq> = props => {
  const tripType = useFieldValue<TripType>('terms.tripType');

  const docs = props.filterFaq
    ? documents[tripType] || documents.TRIP_TYPE_UNSPECIFIED
    : documents.TRIP_TYPE_UNSPECIFIED;

  return <Faq documents={docs} />;
};
